module.exports = __webpack_public_path__ + "img/initiative_block2.5eaf3343.png";